module.exports = __webpack_public_path__ + "img/premium_disabled_mobile.a0bdd346.png";